export default "__VITE_ASSET__DlyJHFKt__"